import { BlockType, LinkType } from "@/libs/types"
import React from "react"
import ContentButton from "./ContentButton"
import ContentHeader from "./ContentHeader"
import ContentMarkdown from './ContentMarkdown'
import ContentMetadata from "./ContentMetadata"
interface ContentProps {
    locale: string
    variant?: "h1" | "h2" | "h3" | "h4"
    block: BlockType
    className?: string
}

const ContentOne: React.FC<ContentProps> = ({ locale, variant = "h1", block, className }) => {
    if (block.title === null && block.content === null && block.description === null) return null;

    return (
        <>
            {(block.content && (block.content !== "")) ? (
                <div className="content-block-one">
                    <ContentMarkdown locale={locale} content={block.content} />
                </div>
            ) : (
                <ContentHeader {...block} variant={variant} />
            )}
            {block?.linked.length !== 0 && (<div className="content-one-button">
                {block.linked.map((linked: LinkType, index: number) => {
                    if (linked.hidden) return null
                    return (
                        <ContentButton key={index} linked={linked} locale={locale} />
                    )
                })}
            </div>)}
            {block.metadata?.pricing && block?.metadata?.pricing?.length !== 0 && <ContentMetadata {...block} locale={locale} />}
        </>
    )
}
export default ContentOne